// Project
import request from "../request";

export const getNotificationProcessingEstimate = async (props) => {
	const { env } = props;

	return request({
		url: `/${env}/notifications/processing-estimate/`,
		method: "GET",
	});
};